import styled from 'styled-components';

export const StyledContainerWrapper = styled.div`
    height: 100%;
    flex-grow: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const StyledContainer = styled.div`
    height: 100%;
    /* flex-grow: 1; */
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export const StyledRow = styled.div`
    width: 100%;
    margin: 30px 120px;
    box-sizing: border-box;
    cursor:pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    @media (max-width: 768px) {
        padding: 25px 20px;
        margin-bottom: 0px;
    }
`;
export const StyledContent = styled.div`
    margin-bottom: 30px;
    width: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 0px 60px 0px 30px;
    margin-bottom: 138px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    @media (max-width: 768px) {
        padding: 0px;
        margin-bottom: 0;
    }
`;
export const StyledSummaryText = styled.div(
    (p) => `
    font-size: ${p.theme.fontSizes.title};
    color: ${p.theme.colors.black};
    font-weight: bold;
    font-style: normal;
    line-height: 24px;
    width: 90%;
    letter-spacing: 0.5px;
`
);
export const StyledBackIcon = styled.img`
    margin-right: 20px;
`;

export const StyledMenuContainer = styled.div`
    padding-top: 40px;
    padding-left: 50px;
    /* padding-right: 50px; */
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    max-height: 100%;
    /* height: 400px; */
    position: sticky;
    top: 32px;
    @media (max-width: 768px) {
        padding: 0px;
        width: 100%;
    }
`;

export const NavigatorContainer = styled.div`
    position: fixed;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    @media (max-width: 768px) {
        max-width: 100%;
        min-width: 0;
        position: fixed;
        right: 0;
        width: 100%;
    }
`;
